import { Link } from "@/components/LocaleLink";
import { ArrowLeft } from "lucide-react";

interface BackNavProps {
  to: string;
  label: string;
}

const BackNav = ({ to, label }: BackNavProps) => {
  return (
    <Link
      to={to}
      className="inline-flex items-center gap-2 font-mono text-sm text-muted-foreground hover:text-foreground transition-colors group"
    >
      <ArrowLeft className="w-4 h-4 transition-transform group-hover:-translate-x-1" />
      <span>{label}</span>
    </Link>
  );
};

export default BackNav;
